import {hideElem, showElem} from '../../utils/dom.ts';

type CropperOpts = {
  container: HTMLElement,
  imageSource: HTMLImageElement,
  fileInput: HTMLInputElement,
};

function isSvgAvatarFile(file: File): boolean {
  return file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg');
}

async function initCompCropper({container, fileInput, imageSource}: CropperOpts) {
  const {default: Cropper} = await import('cropperjs');
  let currentFileName = '';
  let currentFileLastModified = 0;
  let currentIsSvg = false;
  const cropper = new Cropper(imageSource, {
    aspectRatio: 1,
    viewMode: 2,
    autoCrop: false,
    crop() {
      if (currentIsSvg) return;
      const canvas = cropper.getCroppedCanvas();
      canvas.toBlob((blob) => {
        if (!blob || currentIsSvg) return;
        const croppedFileName = currentFileName.replace(/\.[^.]{3,4}$/, '.png');
        const croppedFile = new File([blob], croppedFileName, {type: 'image/png', lastModified: currentFileLastModified});
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(croppedFile);
        fileInput.files = dataTransfer.files;
      });
    },
  });

  fileInput.addEventListener('input', (e) => {
    const files = (e.target as HTMLInputElement).files;
    if (files?.length) {
      currentFileName = files[0].name;
      currentFileLastModified = files[0].lastModified;
      currentIsSvg = isSvgAvatarFile(files[0]);
      if (currentIsSvg) {
        hideElem(container);
        return;
      }
      const fileURL = URL.createObjectURL(files[0]);
      imageSource.src = fileURL;
      cropper.replace(fileURL);
      showElem(container);
    }
  });
}

export async function initAvatarUploaderWithCropper(fileInput: HTMLInputElement) {
  const panel = fileInput.nextElementSibling as HTMLElement;
  if (!panel?.matches('.cropper-panel')) throw new Error('Missing cropper panel for avatar uploader');
  const imageSource = panel.querySelector<HTMLImageElement>('.cropper-source')!;
  await initCompCropper({container: panel, fileInput, imageSource});
}
